import React, { useState } from "react";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import baseUrl from "../../../baseUrl";
import Spinner from "../../../Components/Spinner/Spinner";

const Login = () => {
  const [email, setEmail] = useState("admin@gmail.com");
  const [password, setPassword] = useState("Admin@9817");

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    if (email && password) {
      setLoading(true);
      axios
        .post(`${baseUrl}/admin/login`, {
          email,
          password,
        })
        .then((res) => {
          if (res.data.success === true) {
            localStorage.setItem(
              "EXAMNP:admin-token",
              JSON.stringify(res.data.token)
            );
            localStorage.setItem(
              "EXAMNP:admin-profile",
              JSON.stringify(res.data.admin)
            );
            toast.success(res.data.message);
            navigate("/admin/dashboard");
            window.location.reload();
          } else {
            toast.error(res.data.message);
            navigate("/admin/login");
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      toast.error("Please fill all the fields");
    }
  };

  return (
    <>
      {loading && <Spinner />}
      <div className="text-center mt-20">
        <div className="flex items-center justify-center">
          <Link to="/admin/dashboard">
            <img
              className="w-16 h-16 "
              draggable="false"
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/Emblem_of_Nepal_%282020%29.svg/512px-Emblem_of_Nepal_%282020%29.svg.png"
              alt="logo"
            />
          </Link>
        </div>
        <h2 className="text-2xl tracking-tight capitalize">
          Sign in into admin account
        </h2>
      </div>
      <div className="flex justify-center my-2 mx-4 md:mx-0">
        <form
          className="w-full max-w-xl bg-white rounded-lg shadow-md p-6"
          onSubmit={(e) => {
            handleLogin(e);
          }}
        >
          <div className="flex flex-wrap -mx-3 mb-3">
            <div className="w-full md:w-full px-3 mb-3">
              <label
                className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                htmlFor="Password"
              >
                Email address
              </label>
              <input
                className="appearance-none block w-full bg-white text-gray-900 font-medium border border-gray-400 rounded-lg py-3 px-3 leading-tight focus:outline-none"
                type="email"
                name="email"
                autoComplete="off"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="w-full md:w-full px-3 mb-3">
              <label
                className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                htmlFor="Password"
              >
                Password
              </label>
              <input
                className="appearance-none block w-full bg-white text-gray-900 font-medium border border-gray-400 rounded-lg py-3 px-3 leading-tight focus:outline-none"
                type="password"
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <div className="w-full md:w-full px-3 mb-6">
              <button className="appearance-none block w-full bg-blue-600 text-gray-100 font-bold border border-gray-200 rounded-lg py-3 px-3 leading-tight hover:bg-blue-500 focus:outline-none  focus:border-gray-500">
                Sign in
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default Login;
